import { getStatusColor } from "@/libraries/colors";
import type { User } from "@/types";
import MuiAvatar from "@mui/material/Avatar";
import type { AvatarProps as MuiAvatarProps } from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";

interface AvatarProps extends MuiAvatarProps {
	status?: User["status"];
}

export const StyledBadge = styled(Badge)(({ color = "#00DCFE", theme }) => ({
	"& .MuiBadge-badge": {
		backgroundColor: color,
		color: color,
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			animation: "ripple 1.2s infinite ease-in-out",
			border: "1px solid currentColor",
			content: '""',
		},
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1,
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0,
		},
	},
}));

const Avatar = (props: AvatarProps) => {
	const { status, ...avatarProps } = props;
	const badgeColor = status ? getStatusColor(status) : undefined;
	return (
		<StyledBadge
			overlap="circular"
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			variant="dot"
			color={badgeColor as any}
			invisible={!status}
		>
			<MuiAvatar {...avatarProps} />
		</StyledBadge>
	);
};

export default Avatar;
